import { render, staticRenderFns } from "./loginDekstop.vue?vue&type=template&id=76d84d3b"
import script from "./loginDekstop.vue?vue&type=script&lang=js"
export * from "./loginDekstop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports